<template>
  <div class="detlawbrinfo">
    <div class="cove">
      <img src="~assets/special/lvshicover_sample.png" alt="" />
    </div>
    <div class="lawname"><span>张三</span>律师</div>
    <div class="dizhicye center">
      <div class="adr">
        <img src="~assets/base/zuobiao.png" alt="" />北京-北京-朝阳
      </div>
      <div class="zhiye">执业年限:<span>5</span>年</div>
    </div>
    <div class="biaoq center">
      <div class="lab">专长：</div>
      <div class="tag g1 ellipsis">劳动纠纷</div>
      <div class="tag g2 ellipsis">婚姻家庭</div>
    </div>
    <div class="lawjs">
      {{ `律师介绍：沈辉律师四川循定律师事务所专 职律师沈辉律师自执业以来` }}

      <span>查看更多></span>
    </div>
    <div class="caozuobtn center">
      <div class="btn gd1">查看更多</div>
      <div class="btn gz1">关注+</div>
    </div>
    <div class="lawstatus">
      <span>接单中</span>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.detlawbrinfo {
  width: 100%;
  padding: 38px 24px;
  text-align: center;
  position: relative;
  .cove {
    margin: 10px 0 0;
    img {
      width: 170px;
      height: 170px;
      border-radius: 50%;
    }
  }
  .lawname {
    margin-top: 15px;
    color: #333333;
    font-size: 18px;
    span {
      font-size: 24px;
      margin-right: 5px;
    }
  }
  .dizhicye {
    margin-top: 20px;
    font-size: 14px;
    color: #999999;
    .adr {
      margin-right: 13px;
      img {
        width: 11px;
        height: 13px;
        margin-right: 4px;
      }
    }
    .zhiye {
      span {
        color: #f72929;
      }
    }
  }
  .biaoq {
    margin-top: 20px;
    font-size: 14px;
    color: #333333;
    .tag {
      width: 74px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-radius: 3px;
      margin-right: 10px;
      padding: 0 4px;
      &.g1 {
        background: #dbe3ff;
        color: #174bff;
      }
      &.g2 {
        background: #ffecec;
        color: #fc6969;
      }
    }
  }
  .lawjs {
    margin-top: 25px;
    position: relative;
    font-size: 14px;
    color: #333333;
    text-align: left;
    line-height: 22px;
    span {
      position: absolute;
      right: 0;
      bottom: 0;
      color: #0465ea;
    }
  }
  .caozuobtn {
    margin-top: 30px;
    .btn {
      cursor: pointer;
      width: 129px;
      height: 36px;
      line-height: 36px;
      border-radius: 3px;
      font-size: 16px;
      margin-right: 8px;
      &.gd1 {
        border: 1px solid #0465ea;
        background: #0465ea;
        color: #ffffff;
      }
      &.gz1 {
        border: 1px solid #0465ea;
        background: #fff;
        color: #0465ea;
      }
    }
  }
  .lawstatus {
    position: absolute;
    right: 15px;
    top: 15px;
    font-size: 14px;
    color: #333333;
    &::before {
      content: "";
      position: absolute;
      top: 7px;
      left: -15px;
      width: 8px;
      height: 8px;
      background: #39b95a;
      border-radius: 50%;
    }
  }
}
</style>